<template>
  <cytomine-modal-card :title="$t('about-vidapath')" class="about-vidapath-modal" @close="$parent.close()">
    <template>
      <img class="logo" src="@/assets/brands/vidanex-dark.png">

      <dl>
        <dt>{{ $t('version') }}</dt>
        <dd>{{ version || '?' }}</dd>

        <dt>{{ $t('description') }}</dt>
        <dd>{{ $t('vidapath-description') }}</dd>

        <!-- <dt>{{ $t('funding') }}</dt>
        <dd>
          <i18n path="cytomine-funding">
            <a place="link" href="https://uliege.cytomine.org/#fundings" target="_blank">
              https://uliege.cytomine.org/#fundings
            </a>
          </i18n>
        </dd> -->

        <dt>{{ $t('website') }}</dt>
        <dd>
          <i18n path="cytomine-website-info">
            <a place="websiteLink" href="https://vidanex.com/" target="_blank">
              https://vidanex.com/
            </a>
          </i18n>
        </dd>

        <!-- <dt>{{ $t('source-code') }}</dt>
        <dd>
          <i18n path="source-code-info">
            <a place="link" href="https://github.com/cytomine/cytomine" target="_blank">
              {{ $t('github-repository') }}
            </a>
          </i18n>
        </dd> -->

        <!-- <dt>{{ $t('documentation') }}</dt>
        <dd>
          <i18n path="documentation-info">
            <a place="docLink" href="https://doc.uliege.cytomine.org/" target="_blank">
              https://doc.uliege.cytomine.org/
            </a>
          </i18n>
        </dd> -->

        <dt>{{ $t('contact') }}</dt>
        <dd>
          <i18n path="contact-info">
            <a place="contactMail" href="mailto:hi@vidanex.com">
              hi@vidanex.com
            </a>
          </i18n>
        </dd>
      </dl>
    </template>
  </cytomine-modal-card>
</template>

<script>
import constants from '@/utils/constants.js';

import CytomineModalCard from '@/components/utils/CytomineModalCard';

export default {
  name: 'AboutCytomineModal',
  components: {
    CytomineModalCard,
  },
  data() {
    return {
      version: "1.0.0",
    };
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/dark-variables';

.logo {
  display: block;
  margin: 0 auto 1.15rem;
  max-height: 8.6rem;
  filter: drop-shadow(0 10px 24px rgba(0, 0, 0, 0.24));
}

.modal-card,
.modal-card-body {
  width: 30vw;
  min-width: 400px;
  font-weight: normal;
  color: $dark-text-primary;
}

.modal-card::v-deep .modal-card-title {
  color: $dark-text-primary;
}

.modal-card::v-deep .button {
  background-color: $dark-button-bg;
  border: 1px solid $dark-button-border;
}

.modal-card::v-deep .button:hover {
  background-color: $dark-button-hover-bg;
  border-color: $dark-button-hover-border;
}

dl {
  margin: 0;
  padding: 0.75rem 0.4rem 0.2rem;
}

dt {
  float: left;
  width: 12rem;
  text-align: right;
  padding-right: 1rem;
  clear: both;
  font-weight: 600;
  color: $dark-text-disabled;
  font-size: 0.82rem;
  line-height: 1.6;
  text-transform: uppercase;
}

dd {
  margin-left: 14rem;
  margin-bottom: 0.75rem;
  color: $dark-text-primary;
  padding: 0.35rem 0.6rem;
  border-radius: 6px;
  background: rgba(222, 238, 255, 0.026);
  border: 1px solid rgba(190, 214, 238, 0.09);
  line-height: 1.5;
}

a {
  color: $primary;
  font-weight: 650;
}

a:hover {
  color: #b9f4fb;
}
</style>
